import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Map } from 'immutable'
import _ from 'lodash'

import config from '../../../../config'

import {
    addToFavourites,
    removeFromFavourites,
} from '../EntityStack/components/StackContent/components/FavouritesContent/actions'

import { WITHOUT_TAB } from './constants'

import { toolbarIconClick, toolbarOutsideClick } from './actions'

function mapStateToProps(state) {
    let activeModule = state.getIn(['ui', 'moduleMenu', 'active'], null)
    // hack because of not settings activeModule in store when iframeSolution (Toolbar is hidden -> bug)
    if (config.iframeSolution) {
        const pathModule = _.trim(state.getIn(['router', 'location', 'pathname'], null), '/')
        activeModule = _.get(
            _.find(config.modules, (module) => pathModule === module.route),
            'key',
            null
        )
    }

    const activeTab = state
        .getIn(['ui', 'tabs', 'tabs'])
        .find((tab) => tab.get('type') === activeModule && tab.get('active'))
    const isActiveWithoutTab = _.get(config.modules[activeModule], 'toolbar.withoutTab', false)

    const tabId = (activeTab && activeTab.get('id')) || WITHOUT_TAB // id for callbacks (id of group, entity, etc.)
    const uniqueId = `${activeModule}_${tabId}` // id for toolbar over application

    const showReportIndicator = state.getIn(
        ['ui', 'modules', 'report', 'workspace', tabId, 'blocks', 'indicators', 'data', 'showReport'],
        null
    )

    return {
        tabId,
        uniqueId,
        favourites: state.getIn(['ui', 'entityStack', 'favourites', 'entities']),
        module: activeModule,
        isActive: !!activeTab || isActiveWithoutTab,
        desks: state.getIn(['ui', 'toolbar', uniqueId, 'desks'], Map()),
        showReportIndicator,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            toolbarIconClick,
            addToFavourites,
            removeFromFavourites,
            toolbarOutsideClick,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        static propTypes = {
            desks: IPropTypes.map.isRequired,
            isActive: PropTypes.bool.isRequired,
            module: PropTypes.string.isRequired,
            tabId: PropTypes.string.isRequired,
            uniqueId: PropTypes.string.isRequired,
        }

        render() {
            const { isActive } = this.props

            if (!isActive) return null

            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
